import React, { useState, useEffect } from 'react';
import {
  Box, Button, useTheme, Typography, List, ListItem, ListItemIcon, ListItemButton, ListItemText,
  Paper, Grid
} from '@mui/material';
import { useNavigate } from "react-router-dom";
import {  Divider, Toolbar,  } from '@mui/material';

import SaveIcon from '@mui/icons-material/Save';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { API_ENDPOINTS } from '../../config/api/apiCall';
import { tokens } from '../../theme/theme';
import Header from '../../Layout/Header';
import CallAlertBar from '../../Layout/Alertbar';
import { useParams } from "react-router-dom";

import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { toast } from 'react-toastify';
import { callApi } from '../../utils/apiClient';
const AssignPermissions = () => {
  const { CompanyId } = useParams();
  const [parentModules, setParentModules] = useState([]);
  const [modules, setModules] = useState([]);

  const [permissions, setPermissions] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState('');
  const [selectedRoleName, setSelectedRoleName] = useState('');
  const [modulePermissions, setModulePermissions] = useState({}); // Track selected permissions for each module
  const [userRoles, setUserRoles] = useState([]);
  const [parentModuleSelections, setParentModuleSelections] = useState({});
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
  const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
  const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
  const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

  // Load Modules
  const LoadModules = () => {
    callApi(API_ENDPOINTS.USER_getUserAccessModules, 'POST', { 'Content-Type': 'application/json' })
      .then(data => {
        setModules(data);
      })
      .catch(error => {
        console.error(error);
      });
  };

  // Load Permissions
  const LoadModulePermissions = () => {
    callApi(API_ENDPOINTS.USER_getUserAccessModulesPermissions, 'POST', { 'Content-Type': 'application/json' })
      .then(data => {
        setPermissions(data);
      })
      .catch(error => {
        console.error(error);
      });
  };

  // Load Roles
  const LoadRoleList = () => {
    let requestBody = { CompanyId: CompanyId };
    callApi(API_ENDPOINTS.USER_getUserRoles, 'POST', { 'Content-Type': 'application/json' }, requestBody)
      .then(data => {
        setUserRoles(data);
      })
      .catch(error => {
        console.error(error);
      });
  };

  // Fetch Parent Modules
  const LoadParentModules = () => {
    callApi(API_ENDPOINTS.USER_getParentModules, 'POST', { 'Content-Type': 'application/json' })
      .then(data => {
        setParentModules(data); // Set the parent modules in state
      })
      .catch(error => {
        console.error(error);
      });
  };

  function mapExistingPermissionsToState(existingPermissions) {
    const mappedPermissions = {};

    existingPermissions.forEach(permission => {
      const { module_name, permission_name } = permission;

      if (!mappedPermissions[module_name]) {
        mappedPermissions[module_name] = {
          selected: true, // Pre-select the module checkbox
          permissions: {},
        };
      }

      mappedPermissions[module_name].permissions[permission_name] = true; // Pre-select the permission checkbox
    });

    return mappedPermissions;
  }



  useEffect(() => {
    LoadRoleList();
    LoadModules();
    LoadModulePermissions();
    LoadParentModules();


  }, []);

  useEffect(() => {
    if (userRoles.length > 0) {
      handleRoleSelect(userRoles[0])
    }

  }, [userRoles]);




  function convertToDesiredFormat(data) {
    const roleId = data.RoleId; // Assuming this is properly assigned
    const modulesArray = [];

    // Iterate through each module in the Modules object
    for (const moduleName in data.Modules) {
      const module = data.Modules[moduleName];
      modulesArray.push({
        ModuleName: moduleName,
        Selected: module.selected,
        Permissions: module.permissions,
      });
    }

    return {
      RoleId: roleId, // Ensure this is a valid Role ID
      Modules: modulesArray,
    };
  }



  const handleParentModuleCheck = (parentModuleId) => (event) => {
    const isChecked = event.target.checked;

    // Update parent module selections
    setParentModuleSelections((prev) => ({
      ...prev,
      [parentModuleId]: isChecked,
    }));

    // Update child modules and their permissions
    setModulePermissions((prev) => {
      const updatedPermissions = { ...prev };

      // Get all child modules associated with the parent
      const childModules = modules.filter(module => module.parent_module_id === parentModuleId);

      childModules.forEach(module => {
        // Ensure permissions for the child module are initialized
        if (!updatedPermissions[module.module_name]) {
          updatedPermissions[module.module_name] = {
            selected: isChecked,
            permissions: {}, // Initialize the permissions object
          };
        }

        // Update all permissions for the child module
        permissions.forEach(permission => {
          updatedPermissions[module.module_name].permissions[permission.permission_name] = isChecked;
        });
      });

      return updatedPermissions;
    });
  };



  const handleSubmit = (event) => {
    event.preventDefault();

    if (selectedRoleId === 0 || selectedRoleId === '') {
      

         toast.warning("Please select the User Role for assign the permisson.!", { position: toast.POSITION.BOTTOM_CENTER });

      return;
    }

    const payload = {
      RoleId: selectedRoleId,
      Modules: modulePermissions, // Send selected permissions for each module
    };

    // Convert the data
    const transformedPayload = convertToDesiredFormat(payload);

    // Log the result
    console.log(JSON.stringify(transformedPayload, null, 2));

    callApi(API_ENDPOINTS.USER_insertRoleModulePermissions, 'POST', { 'Content-Type': 'application/json' }, transformedPayload)
      .then(data => {

        // setParentRollSeverityvalue('success');
        // setParentRollMessageValue(`Permissions successfully assigned to the user role: ${selectedRoleName}.`);

        // setParentRollAlertTitleValue('Success');
        // setParentRollMsgOpen(true);

       toast.success(`Permissions have been successfully assigned to the role "${selectedRoleName}".`, {
  position: toast.POSITION.BOTTOM_CENTER,
  
});


      })
      .catch(error => {


        setParentRollSeverityvalue('error');
        setParentRollMessageValue(error.message);
        setParentRollAlertTitleValue('Error');
        setParentRollMsgOpen(true);
      });
  };

  const handleRoleSelect = (role) => {

    let roleId = role.role_id
    setSelectedRoleId(roleId);
    setSelectedRoleName(role.role_name);
    setModulePermissions({}); // Reset permissions when role changes

    const retrievedUserID = localStorage.getItem('userID');

    let requestBody = { userid: retrievedUserID, roleid: roleId };


    // Make an API call to fetch existing permissions for the selected role
    callApi(API_ENDPOINTS.USER_getRoleModulePermissionsByRoleID, 'POST', { 'Content-Type': 'application/json' }, requestBody)
      .then(existingPermissions => {
        // Convert the existing permissions into a format that will pre-select checkboxes
        const mappedPermissions = mapExistingPermissionsToState(existingPermissions);
        setModulePermissions(mappedPermissions); // Update the modulePermissions state
      })
      .catch(error => {
        console.error(error);
      });
  };

  // Handle Module Checkbox
  const handleModuleCheck = (moduleName) => (event) => {
    setModulePermissions((prev) => ({
      ...prev,
      [moduleName]: {
        ...prev[moduleName],
        selected: event.target.checked, // Select or unselect the entire module
      },
    }));


  };

  // Handle Permission Checkbox
  const handlePermissionCheck = (moduleName, permissionName) => (event) => {
    setModulePermissions((prev) => ({
      ...prev,
      [moduleName]: {
        ...prev[moduleName],
        permissions: {
          ...prev[moduleName]?.permissions,
          [permissionName]: event.target.checked, // Track permission selection for the module
        },
      },
    }));
  };

  const navigate = useNavigate();
  const handleBackDashboard = () => {
    const url = `/UserList/${CompanyId}`;
    //const url = `/newordercreate/${IndentId}/${ConfirmationOrderId}`;
    navigate(url);
  }

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{ display: 'flex', flexDirection: 'column', gap: 0, margin: '0 auto' }}
    >

      <Header title={'User Role Permissions'} subtitle="" callback={handleBackDashboard} />
      <Divider />


      <CallAlertBar
        parentRollMsgOpen={parentRollMsgOpen}
        setParentRollMsgOpen={setParentRollMsgOpen}
        parentRollSeverityvalue={parentRollSeverityvalue}
        setParentRollSeverityvalue={setParentRollSeverityvalue}
        parentRollAlertTitleValue={parentRollAlertTitleValue}
        setParentRollAlertTitleValue={setParentRollAlertTitleValue}
        parentRollMessageValue={parentRollMessageValue}
        setParentRollMessageValue={setParentRollMessageValue}
      />


      <Grid container padding={1} spacing={2}>
        {/* Left Side - User Roles List */}
        <Grid item xs={3} >
          <Paper sx={{ backgroundColor: 'transparent', borderLeft: '2px solid rgb(116, 156, 213)', padding: 1, maxHeight: '480px', overflowY: 'auto' }}>
            <Typography fontWeight={'bold'} variant='h5'>User Role List</Typography>


            <List>
              {userRoles.map((role) => (
                <ListItem disablePadding key={role.role_id}>
                  <ListItemButton
                    selected={role.role_id === selectedRoleId}
                    onClick={() => handleRoleSelect(role)}
                    sx={{
                      '&.Mui-selected': {
                        bgcolor: 'primary.main',
                        color: 'white',
                        '&:hover': {
                          bgcolor: 'primary.dark',
                        },
                      },
                    }}
                  >
                    <ListItemIcon>
                      <VerifiedUserIcon size='small' color={role.role_id === selectedRoleId ? 'success' : 'disabled'} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography variant="body1" fontWeight={500}>
                          {role.role_name}
                        </Typography>
                      }
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>


          </Paper>
          <Typography variant="h6" mt={2}>
            Selected User Role :
            <div>
              <span style={{fontWeight: 'bold', color: '#3498db', fontSize: '22px', }}>{selectedRoleName}</span>
            </div>
          </Typography>


        </Grid>

        {/* Right Side - Modules and Permissions */}

        <Grid item xs={9}>

          <Typography mb={1} fontWeight={'bold'} variant='h4'>Modules List</Typography>
          <Divider />

          <Box
            sx={{
              // backgroundColor: colors.primary[700],
              padding: "5px",
              borderRadius: "10px",
              maxHeight: {
                xs: '72vh', // Extra small devices (phones)
                sm: '72vh', // Small devices (tablets)
                md: '74vh', // Medium devices (small laptops)
                lg: '74vh', // Large devices (desktops)
                xl: '82vh', // Extra large devices (large desktops)
              },
              overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: colors.primary[400],
                borderRadius: '10px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: colors.blueAccent[600],
                borderRadius: '10px',
                '&:hover': {
                  background: colors.blueAccent[800],
                },
              },
              '&::-webkit-scrollbar-corner': {
                background: colors.primary[700],
              }
            }}>




            {parentModules.map((parentModule) => (
              <div key={parentModule.parent_module_id}>

                <FormControlLabel
                  control={
                    <Checkbox
                      size='small'
                      checked={!!parentModuleSelections[parentModule.parent_module_id]}
                      onChange={handleParentModuleCheck(parentModule.parent_module_id)}
                      sx={{
                        color: 'lightblue',
                        transition: 'all 0.3s ease', // Smooth animation for color/transform
                        transform: 'scale(1)',
                        '&.Mui-checked': {
                          color: '#31a4ddff', // Light blue
                          transform: 'scale(1.2)', // Scale up when checked
                        },
                        '&:hover': {
                          backgroundColor: 'rgba(66, 165, 245, 0.08)',
                          borderRadius: '4px',
                        },
                        padding: '4px',
                      }}
                    />
                  }
                  label={parentModule.parent_module_name}
                // onClick={(e) => e.stopPropagation()} // Add this too to be extra safe
                />

                {modules.filter(module => module.parent_module_id === parentModule.parent_module_id).map((module) => (
                  <Accordion key={module.module_name} size="small" defaultExpanded={false} sx={{ backgroundColor: colors.primary[400], marginLeft: '20px', borderRadius: '10px' }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel-${module.module_name}-content`}
                      id={`panel-${module.module_name}-header`}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            size='small'
                            checked={!!modulePermissions[module.module_name]?.selected}
                            onChange={handleModuleCheck(module.module_name)}
                            sx={{
                              color: 'lightblue',
                              transition: 'all 0.3s ease', // Smooth animation for color/transform
                              transform: 'scale(1)',
                              '&.Mui-checked': {
                                color: '#31a4ddff', // Light blue
                                transform: 'scale(1.2)', // Scale up when checked
                              },
                              '&:hover': {
                                backgroundColor: 'rgba(66, 165, 245, 0.08)',
                                borderRadius: '4px',
                              },
                              padding: '4px',
                            }}
                          />
                        }
                        label={module.module_name}
                        onClick={(event) => event.stopPropagation()}
                      />
                    </AccordionSummary>
                    <AccordionDetails>
                      {permissions.map((permission) => (
                        <FormControlLabel
                          key={permission.permission_name}
                          control={
                            <Checkbox
                              size='small'
                              checked={!!modulePermissions[module.module_name]?.permissions?.[permission.permission_name]}
                              onChange={handlePermissionCheck(module.module_name, permission.permission_name)}
                              sx={{
                                color: 'lightblue',
                                transition: 'all 0.3s ease', // Smooth animation for color/transform
                                transform: 'scale(1)',
                                '&.Mui-checked': {
                                  color: '#31a4ddff', // Light blue
                                  transform: 'scale(1.2)', // Scale up when checked
                                },
                                '&:hover': {
                                  backgroundColor: 'rgba(66, 165, 245, 0.08)',
                                  borderRadius: '4px',
                                },
                                padding: '4px',
                              }}
                            />
                          }
                          label={permission.permission_name}
                        />
                      ))}
                    </AccordionDetails>
                  </Accordion>
                ))}
              </div>
            ))}


          </Box>
        </Grid>
      </Grid>




      <Divider sx={{ marginBottom: 1 }} />
      <Box
        position="fixed"
        sx={{
          bottom: 0,
          right: 0,
          backgroundColor: 'transparent',
          zIndex: 1200, // Make sure it floats above everything

          py: 0, // vertical padding
        }}
      >

        <Toolbar sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
  variant="contained"
  color="primary"
  startIcon={<SaveIcon />}
  size="medium"
  sx={{
     fontSize: '13px',
    // padding: '8px 20px',
    // borderRadius: '12px',
    // boxShadow: '0 3px 6px rgba(0,0,0,0.1)',
    textTransform: 'none',
    backgroundColor: '#3d8dc2ff', // nice blue
    '&:hover': {
      backgroundColor: '#3d8dc2ff',
    },
  }}
  type="submit"
>
  Save
</Button>

        </Toolbar>
      </Box>


    </Box>
  );
};

export default AssignPermissions;
